import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { DealStatus } from 'components/common/types/Deal.types';
import PlannerSecondaryPanel from 'components/pages/Planner/PlannerSecondaryPanel';
import { hidePlannerSecondaryPanel } from 'store/dealManagement/reducer';
import usePendoTracking from 'customHooks/usePendoTracking';
import { getIsProgrammaticCampaignType } from 'store/dealManagement/selectors/getCampaignType';
import { ProgrammaticStatusOption } from './CampaignBookingStatus.types';

interface CampaignBookingStatusPanelProps {
  onConfirm: (status: DealStatus) => void;
  statusOptions: ProgrammaticStatusOption[];
}

export const CampaignBookingStatusPanel: React.FC<CampaignBookingStatusPanelProps> = ({ onConfirm, statusOptions }) => {
  const dispatch = useDispatch();

  const { getPendoDataId } = usePendoTracking();
  const isProgrammaticCampaignType = useSelector(getIsProgrammaticCampaignType);

  const [selectedStatus, setSelectedStatus] = useState<ProgrammaticStatusOption | undefined>();

  const handleCancel = (): void => {
    dispatch(hidePlannerSecondaryPanel());
  };

  const handleSubmit = (): void => {
    if (selectedStatus?.code) {
      onConfirm(selectedStatus.code as DealStatus);
      dispatch(hidePlannerSecondaryPanel());
    }
  };

  const handleSelectStatus = (selectedStatusOption: ProgrammaticStatusOption) => () => {
    setSelectedStatus(selectedStatusOption);
  };

  return (
    <PlannerSecondaryPanel
      confirmButtonLabel="Update status"
      customStyles={{ left: '89px', top: '150px', maxHeight: '242px', width: '309px' }}
      isDisabled={!selectedStatus?.code}
      isLineLevel={false}
      onCancel={handleCancel}
      onSubmit={handleSubmit}
      showName={false}
    >
      <div className="flex flex-col gap-0.5" data-test-id="status-options">
        {statusOptions.map(
          (option) =>
            option.isVisible && (
              <button
                className={cx('p-[8px] body-base text-left', {
                  'bg-primary-100': selectedStatus?.code === option.code,
                  'cursor-not-allowed text-neutral-600': option.isDisabled,
                })}
                disabled={option.isDisabled}
                key={option.code}
                onClick={handleSelectStatus(option)}
                data-pendo-id={isProgrammaticCampaignType ? getPendoDataId(option.name) : undefined}
                type="button"
              >
                {option.name}
              </button>
            ),
        )}
      </div>
    </PlannerSecondaryPanel>
  );
};
